import s from './ProgressBar.module.scss'
import type { ProgressBarProps } from './ProgressBar.props'

export function ProgressBar({ total, current }: ProgressBarProps) {
  return (
    <div className={s.wrapper}>
      <div
        className={s.progress}
        style={{ width: `${(current / total) * 100}%` }}
      />
    </div>
  )
}
